import script from "./OrderPaymentSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPaymentSuccess.vue?vue&type=script&setup=true&lang=js"

import "./OrderPaymentSuccess.vue?vue&type=style&index=0&id=1b371708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b371708"]])

export default __exports__